import axios from 'common/bsac-api.js';
import constants from 'common/constants';
import environments from 'constant/environments'
import prototype from 'prototype/admin-user';

const state = {
  adminUser: null,
};

const getters = {
  /**
   * ユーザーオブジェクトを取得する
   * @param {*} getters
   * @returns
   */
  adminUser: (state) => state.adminUser,
  /**
   * 認証用ヘッダーを取得する
   * @param {*} getters
   * @returns
   */
  authHeaders: (state) => {
    return {
      headers: {
        'access-token': state.adminUser.accessToken,
        client: state.adminUser.client,
        uid: state.adminUser.uid,
      },
    };
  },
  /**
   *　認証状態を取得する
   * @param {*} state
   * @returns
   */
  isAuthenticated: (state) => {
    return state.adminUser && state.adminUser.accessToken !== null;
  },
};

const mutations = {
  /**
   * データをクリアする
   * @param {*} state
   */
  clearData(state) {
    state.adminUser = new prototype.AdminUser();
  },
  /**
   * ユーザー情報をセットする
   * @param {*} state
   * @param {*} user
   */
  setAdmin(state, response) {
    let adminUser = new prototype.AdminUser();
    adminUser.setApiData(response.headers);
    adminUser.setApiData(response.data.data);
    state.adminUser = adminUser;
  },
};

const actions = {
  /**
   * ログインする
   * @param {*} param0
   * @param {*} payload
   * @returns
   */
  signin({ commit, dispatch }, payload) {
    const url = `${constants.ADMIN_AUTH_URL}/sign_in`;

    if (environments.isDevelop()) console.log(`[admin.js] header: ${JSON.stringify(payload, null, '\t')}`);
    if (environments.isDevelop()) console.log(`[admin.js] url: ${url}`);
    
    return axios
      .post(url, {
        email: payload.email,
        password: payload.password,
      })
      .then((response) => {
        // if (environments.isDevelop()) console.log(`[admin.js] response: ${JSON.stringify(response, null, '\t')}`);
        commit('setAdmin', response);
        return {
          success: true,
          status: null,
          message: null,
        };
      })
      .catch((error) => {
        // if (environments.isDevelop()) console.log(`[admin.js] error: ${JSON.stringify(error, null, '\t')}`);
        return {
          success: false,
          status: null,
          message: 'ログインID、またはパスワードが異なります。',
        };
      });
  },
  /**
   * ログアウトする
   * @param {*} param0
   * @returns
   */
  signout({ commit, getters, state }) {
    const headers = getters['authHeaders'];
    // console.log(`headers:${JSON.stringify(headers)}`);
    if (!headers) return;
    return axios
      .delete(`${constants.ADMIN_AUTH_URL}/sign_out`, headers)
      .then((response) => {
        // console.debug(response);
        commit('clearData');
        return {
          success: true,
          status: null,
          message: null,
        };
      })
      .catch((error) => {
        // console.error(error.response);
        return {
          success: false,
          status: null,
          message: 'ログアウトに失敗しました',
        };
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
